var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, Renderer2 } from '@angular/core';
import { AuthBaseComponent } from '../auth-base/auth-base.component';
import { ModalService } from 'hsg';
import { AuthUserService } from '../auth-user.service';
var AuthValidateDetailsComponent = /** @class */ (function (_super) {
    __extends(AuthValidateDetailsComponent, _super);
    function AuthValidateDetailsComponent(renderer, modalService, authService) {
        var _this = _super.call(this, modalService, authService) || this;
        _this.renderer = renderer;
        _this.modalService = modalService;
        _this.authService = authService;
        _this.data = {};
        _this.loginOriginAction = "";
        return _this;
    }
    AuthValidateDetailsComponent.prototype.ngOnInit = function () {
        var element = this.renderer.selectRootElement('#uid');
        setTimeout(function () { return element.focus(); }, 0);
        this.authUserService.sendAuthData("ElasticLogger", { elasticCode: '2102' })
            .subscribe(function (res) { return console.log("sent elasticLog code:2102 - open window", res); }, function (error) { return console.log("sent elasticLog - open window error!", error); });
        sessionStorage.setItem("currentWindow", "בדיקת פרטים אישיים");
        sessionStorage.setItem("elasticCode", "2186");
        this.data = this.modalService.data;
        this.isShowContactLink = this.shouldContactLink('authValidateDetails');
        this.loginOriginAction = sessionStorage.getItem("loginOriginAction");
    };
    AuthValidateDetailsComponent.prototype.submit = function (form) {
        var _this = this;
        var element = this.inputsQuery.map(function (elm) { return elm.elementRef.nativeElement; }).find(function (elm) { return elm.classList.contains('ng-invalid'); });
        if (element) {
            element.setAttribute('aria-invalid', true);
            setTimeout(function () { return element.focus(); }, 0);
        }
        if (form.valid) {
            this.pending = true;
            this.serverError = null;
            //console.log("sent parametes", { UserId: form.value.uid, FullPhone: form.value.phone });
            this.authUserService.sendAuthData("ValidateDetails", { UserId: form.value.uid, FullPhone: form.value.phone })
                .subscribe(function (res) {
                _this.modalService.close(res.Details);
            }, function () { return _this.pending = false; }, function () { return _this.pending = false; });
        }
        this.buildFormAccessibility();
    };
    return AuthValidateDetailsComponent;
}(AuthBaseComponent));
export { AuthValidateDetailsComponent };
